// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import IconLargeArrowLeft from "@conklin/XDL/Icons/IconLargeArrowLeft";
import IconLargeArrowRight from "@conklin/XDL/Icons/IconLargeArrowRight";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { xBaseTheme } from "@conklin/XDL/types";
import { color, xScreen } from "@conklin/XDL/Utilities";
import { ButtonIcon } from "@insite/mobius/Button";
import { IconWrapper } from "@insite/mobius/Icon";
import PaginationPresentationPropsDefault from "@insite/mobius/Pagination/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...PaginationPresentationPropsDefault,
        mergeCss: true,
        navIconsSrc: {
            ...PaginationPresentationPropsDefault?.navIconsSrc,
            nextPage: IconLargeArrowRight,
            previousPage: IconLargeArrowLeft,
        },
        buttonProps: {
            mergeCss: true,
            sizeVariant: "small",
            css: css`
                margin: 0;
                border: none;
                background: none;

                ${ButtonIcon} {
                    color: ${color("common.ui7")};
                }

                &:disabled ${ButtonIcon} {
                    color: ${color("common.ui4", 0.33)};
                }

                &:not(:disabled):hover {
                    ${ButtonIcon} {
                        color: ${color("common.ui10")};
                    }
                }
                ${IconWrapper}, svg {
                    width: auto;
                }
            `,
        },
        cssOverrides: {
            pagination: css`
                gap: 10px 32px;
                background-color: ${color("common.ui2")};
                border-radius: 4px;
                padding: 8px;
                ${xScreen("lte", "sm")} {
                    margin: 16px 0;
                }
                .pagination-container {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    & > .pagination-element {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        & .page-count {
                            white-space: nowrap;
                        }
                    }
                }
                ${xScreen("lte", "sm")} {
                    justify-content: space-between;
                    &:has(> *:only-child) {
                        justify-content: flex-end;
                    }
                    gap: 10px 0;
                }

                &.pagination-bg-color {
                    padding: 8px;
                    margin: 16px 0;
                    background-color: ${color("common.ui2")};
                    justify-content: flex-end;
                }
            `,
        },
        selectProps: {
            cssOverrides: {
                formField: css`
                    width: unset;
                    padding-right: 0;
                    align-items: center;
                `,
                formInputWrapper: css`
                    width: auto;
                    max-width: 75px;
                    min-width: 53px;
                    &&&& {
                        select {
                            padding-right: 22px;
                        }
                    }
                    ${xScreen("lte", "md")} {
                        width: inherit;
                    }
                `,
            },
            labelProps: {
                mergeCss: true,
                size: 12,
                weight: fontConfig.weight.regular,
                color: "text",
                css: css`
                    letter-spacing: 0;
                    line-height: 15px;
                    min-height: initial;
                `,
            },
        },
    },
} as xBaseTheme["pagination"];
